<template>
    <form-wrapper @submit="handleFormSubmission(data)">
        <form-row>
            <form-cell>
                <text-field
                    :label="$t('forms.auth.forgot_password.fields.email.label')"
                    :placeholder="$t('forms.auth.forgot_password.fields.email.placeholder')"
                    :hasAutofocus="true"
                    :isRequired="true"
                    :formData="data"
                    :error="errorMessage"
                    valuePath="email"
                    type="email"
                    @change="change($event)"
                ></text-field>
            </form-cell>
        </form-row>

        <template #footer>
            <common-buttons>
                <common-button
                    :isProcessing="isSending"
                    :label="$t('forms.auth.forgot_password.microcopy.reset_password')"
                    type="primary"
                ></common-button>
            </common-buttons>
        </template>
    </form-wrapper>
</template>

<script>
    import FormMixin from 'mixins/FormMixin'
    import AuthAPI from 'api/AuthAPI'

    export default {
        mixins: [FormMixin],

        data() {
            return {
                errorMessage: null,
            }
        },

        methods: {
            handleFormSubmission({ email }) {
                this.handleRequest(AuthAPI.forgotPassword(email)).then(() => this.emitEvent({ name: 'sent', payload: this.data }))
            },
        },

        mounted() {
            if (this.$route.query.email) {
                this.data.email = this.$route.query.email
                if (this.$route.query.isPasswordExpired) {
                    this.errorMessage = this.$t('forms.auth.forgot_password.microcopy.password_expired')
                }
            }
        },
    }
</script>
